import React from "react";
import styled from "styled-components";

import { InfoLayoutColumn } from "./InfoLayoutColumn";

/**
 * Info layout column right
 *
 * Usage: InfoLayoutWrapper > InfoLayoutColumnRight
 */
export const InfoLayoutColumnRight: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => {
  const { children, ...rest } = props;

  return (
    <InfoLayoutColumnRightStyled {...rest}>
      {children}
    </InfoLayoutColumnRightStyled>
  );
};

const InfoLayoutColumnRightStyled = styled(InfoLayoutColumn)`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 768px) {
    padding-left: 1%;
    width: 50%;
  }

  @media (min-width: 1380px) {
    width: 40%;
  }
`;
